module.exports = __webpack_public_path__ + "img/ic_unionpay.f829f2b.svg";